import * as React from 'react';

import BaseIcon from 'shared/newComponents/icons/BaseIcon';
import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';

const VcRuIcon: React.FC<CommonIconProps> = (props: CommonIconProps) => {
  return (
    <BaseIcon
      iconSize={IconSize.XL}
      svgProps={{ viewBox: '0 0 32 32' }}
      {...props}
    >
      <g clipPath="url(#clip0_8891_3097)">
        <path
          d="M28 -0.400391H4C1.79086 -0.400391 0 1.39047 0 3.59961V27.5996C0 29.8087 1.79086 31.5996 4 31.5996H28C30.2091 31.5996 32 29.8087 32 27.5996V3.59961C32 1.39047 30.2091 -0.400391 28 -0.400391Z"
          fill="#FFF5F7"
        />
        <path
          d="M22.8583 14.9296C24.6617 14.9296 26.0193 14.1783 27.0203 12.8703L25.6824 11.8495C25.3519 12.285 24.9249 12.6379 24.4348 12.8803C23.9447 13.1225 23.405 13.2477 22.8583 13.2459C20.9011 13.2459 19.4829 11.6515 19.4829 9.69498C19.4829 7.73849 20.878 6.05422 22.9141 6.05422C23.8191 6.05422 24.4589 6.2679 25.0169 6.6136V8.33394H26.7005V5.82557L26.378 5.57172C25.4524 4.84356 24.039 4.45703 22.8576 4.45703C19.9695 4.45703 17.6203 6.8062 17.6203 9.69432C17.6203 12.5797 19.9688 14.9296 22.8583 14.9296ZM26.3514 25.2599L26.2915 22.8488V16.965H22.78V18.6493H24.5181V22.6412C24.5181 24.3608 23.2046 25.5783 21.8797 25.5783C20.5547 25.5783 19.8633 24.6596 19.8633 22.9406V16.9643H16.5832V18.6486H18.0899V23.2326C18.0899 25.5654 19.3979 27.1728 21.7306 27.1728C23.0713 27.1728 24.0921 26.4289 24.7011 25.2823H24.7284L24.9685 26.8856H27.6668V25.2619H26.3535V25.2585L26.3514 25.2599ZM17.2324 4.70407H14.3062L11.761 12.0945H11.7216L9.19005 4.70407H6.0719V6.38901H7.8256L10.8437 14.8125H12.447V14.8104L15.5944 6.3897H17.231V4.70475L17.2324 4.70407ZM3.3335 26.9074H5.06746V25.1741H3.33417L3.3335 26.9074ZM10.0298 18.918H10.0108L9.90187 16.965H6.80686V18.5003H8.45372V25.2605H6.80686V26.8849H14.4559V25.2925H10.1972V21.2128C10.3898 19.7361 11.497 18.475 13.0078 18.475H13.035L13.0044 19.9845H14.688V16.9371H13.3569C11.8325 16.933 10.7015 17.7578 10.0291 18.9188L10.0298 18.918Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_8891_3097">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
};

export default VcRuIcon;
